<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
      title="Orderregel toevoegen"
      :large="true"
      :addClose="true"
      @close="close"
    >
      <slot name="load">

      </slot>
      <dean-notification :is-modal="true">

      </dean-notification>

      <fade-transition group>
        <dean-select-form-row id="product" label="product" placeholder="kies een product" key="product"
                              :value="currentProductLabel"
                              :options="productOptions" :warning="$v.data.product.$error"
                              @input="productChanged" :requiredField="true"
        ></dean-select-form-row>
        <dean-select-form-row v-if="currentProductLabel && productHasAddress"
                              id="address" label="adres" placeholder="kies een adres" key="address"
                              :value="currentAddressLabel"
                              :options="addressOptions" :warning="$v.data.address.$error"
                              @input="addressChange" :requiredField="true"
                              :clearable="true"
        ></dean-select-form-row>
        <dean-form-row id="connectPrice" label="aansluitkosten" type="number" v-model="data.connectPrice"
                       key="connectPrice" :disabled="true"
                       :requiredField="true" step="0.01" :warning="$v.data.connectPrice.$error"></dean-form-row>
        <dean-form-row id="recurringPrice" label="maandelijkse kosten" type="number" v-model="data.recurringPrice"
                       key="recurringPrice" :disabled="true"
                       :requiredField="true" step="0.01" :warning="$v.data.recurringPrice.$error"></dean-form-row>
        <dean-form-row id="disconnectPrice" label="afsluitkosten" type="number" v-model="data.disconnectPrice"
                       key="disconnectPrice" :disabled="true"
                       :requiredField="true" step="0.01" :warning="$v.data.disconnectPrice.$error"></dean-form-row>
        <date-input
            label="wensdatum"
            :value="wishDate"
            key="wishDate"
            :min-date="productMinDate"
            :max-date="productMaxDate"
            :required-field="true"
            :warning="$v.data.wishDate.$error"
            @dateValueChanged="wishDateValueChanged"></date-input>
      </fade-transition>

      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Annuleren</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="save()">Versturen</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import axios from 'axios';
import {
    // SVG
    warningIcon,
    // COMPONENTS
    deanDialog,
    deanDialogButtonGroup,
  } from '@deanone/dean-components';
import deanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
import deanButton from '@/components/deanComponents/deanButton.vue';
import DeanNotification from '@/components/deanComponents/deanNotification.vue';
import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
import {deanDialogBus} from '@/main';
import {validationMixin} from 'vuelidate';
import {required, minValue} from 'vuelidate/lib/validators';
import {Validations} from 'vuelidate-property-decorators';
import {createNotification} from '@/mixins/validations';
import {FadeTransition} from 'vue2-transitions';
import DateInput from '@/components/DateInput.vue';
import {wishDateValidator} from '@/mixins/validators';
import {ServiceTagEnum} from "@/enums/ServiceTagEnum";


@Component({
    components: {
      warningIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanFormRow,
      deanSelectFormRow,
      deanDialogButtonGroup,
      FadeTransition,
      DateInput,
    },
    mixins: [validationMixin],
  })

  export default class OrderAddOrderlineDialog extends Vue {
    @Validations()
    get validations() {
      const valData: any = {
        data: {
          product: {required},
          connectPrice: {required, minValue: minValue(0)},
          recurringPrice: {required, minValue: minValue(0)},
          disconnectPrice: {required, minValue: minValue(0)},
          wishDate: {
            required,
            wishDateValidator: wishDateValidator(
                this.productMinDate ? this.productMinDate.toDateString() : null,
                this.productMaxDate ? this.productMaxDate.toDateString() : null
            )
          },
        },
      };
      if (this.productHasAddress) {
        valData.data.address = {required};
      }
      return valData;
    }

    get productOptions() {
      return this.products.map((product: any) => {
        return {value: product.id, label: `${product.privateName} / ${product.code}`};
      });
    }

    get addressOptions() {
      return this.addresses.map((address: any) => {
        return {value: address.id, label: address.label};
      });
    }

    get wishDate(): string {
      return this.data.wishDate;
    }
    // DATA
    @Prop() public payloadData!: {
      [key: string]: {
        [key: string]: string,
      };
    };
    public data: {[key: string]: any} = {
      product: null,
      address: null,
      connectPrice: null,
      serviceId: null,
      recurringPrice: null,
      disconnectPrice: null,
      wishDate: '',
      minDate: '',
    };
    public products: any = [];
    public addresses: any = [];
    public currentProductLabel = null;
    public currentAddressLabel = null;
    public productHasAddress: boolean = false;
    public today: string = new Date().toISOString().split('T')[0];
    private productMinDate: null|Date = null;
    private productMaxDate: null|Date = null;

    public wishDateValueChanged(data: string) {
      this.data.wishDate = data;
    }

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public save() {
      // @ts-ignore-next-line
      this.$v.data.$touch();

      if (!this.$v.$invalid) {
        this.$emit('setLoad', true);
        axios.post('/-/trade/api/order.line.add', {
          transactionId: this.payloadData.id,
          productId: this.data.product,
          connectPrice: this.data.connectPrice,
          recurringPrice: this.data.recurringPrice,
          disconnectPrice: this.data.disconnectPrice,
          wishDate: this.data.wishDate,
          addressId: this.data.address,
        }).then(
          (response) => {
            deanDialogBus.$emit('saved');
            this.$toast(this.$store.state.main.notification.messages.dataSaved);
            this.close();
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotSaveData);
          },
        ).finally(() => {
          this.$emit('setLoad', false);
        });
      } else {
        this.$toast(createNotification(this.$v));
      }
    }

    public productChanged(currentField: any) {
      this.currentProductLabel = currentField.label;
      const currentProduct = this.products.find((product: any) => {
        return product.id === currentField.value;
      });

      if (
          currentProduct.serviceTags?.includes(ServiceTagEnum.CONNECTION)
          || currentProduct.tags?.includes(ServiceTagEnum.HARDWARE)
      ) {
        this.data.address = this.addressOptions[0].value;
        this.currentAddressLabel = this.addressOptions[0].label;
        this.productHasAddress = true;
      } else {
        this.data.address = undefined;
        this.currentAddressLabel = null;
        this.productHasAddress = false;
      }

      if (currentProduct) {
        this.data = {...this.data, ...{
          product: currentProduct.id,
          connectPrice: currentProduct.prices.connectPrice,
          recurringPrice: currentProduct.prices.recurringPrice,
          disconnectPrice: currentProduct.prices.disconnectPrice,
        }};
      }
    }

    public addressChange(currentField: any) {
      this.currentAddressLabel = currentField.label;
      this.data.address = currentField.value;
    }

    public created() {
      this.$emit('setLoad', true);

      const promises = [];

      promises.push(
          axios.post('/-/trade/api/order.products.list', {
            transactionId: this.payloadData.id,
          }).then(
              (response: any) => {
                this.products = response.data;
              },
              (error) => {
                this.$toast(this.$store.state.main.notification.messages.couldNotReceiveDataModal);
              },
          ),
      );

      promises.push(
          axios.post('/-/trade/api/person.addresses.list', {
            id: this.payloadData.customerId,
          }).then(
              (response: any) => {
                this.addresses = response.data;
              },
              (error) => {
                this.$toast(this.$store.state.main.notification.messages.couldNotReceiveDataModal);
              },
          ),
      );

      Promise.all(promises).finally(() => {
        this.$emit('setLoad', false);
      });
    }

    @Watch('data.product')
    private getMinAndMaxDateForProduct(): void {
      if (this.data.product) {
        axios
          .post('/-/trade/api/productWishDate.info', {productId: this.data.product})
          .then(
              (response: any) => {
                this.productMinDate = response.data.minDate ? new Date(response.data.minDate) : null;
                this.productMaxDate = response.data.maxDate ? new Date(response.data.maxDate) : null;
              },
              (error: any) => {
                // tslint:disable-next-line:no-console
                console.error(error);
              },
          );
      }
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>

.dialog :deep(.dean-dialog-container) {
  max-width: 800px;
}

:deep(.dialog .dean-dialog-container .dean-dialog-content .dean-dialog-slot) {
  overflow-y: visible;
}

</style>
